var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-box",class:{ show: _vm.flag }},[_c('div',{staticClass:"modal-box-wrap",class:{ 'modal-box-wrap-large': _vm.large },style:({
      'max-width': _vm.size ? _vm.size + 'px' : '558px',
      width: _vm.wrap ? 'auto' : '100%',
    })},[_vm._t("default"),_vm._v(" "),_c('ns-img',{staticClass:"modal-close",attrs:{"src":require('assets/images/close.svg')},on:{"click":_vm.closeFlag}})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }